import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { LogAssignation } from '../model/log-assignation';

@Injectable({
    providedIn: 'root'
  })
  export class LogAssignationService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    getLogAssignationByRequestAndTask(requestId, taskdefinitionkey) {
        return this._restClientService.load<LogAssignation[]>('log-assignation/assignations-request-and-task'+
        '?requestid='+requestId+
        '&taskdefinitionkey='+taskdefinitionkey
        );
    }

}      

    